import React from 'react';

import { getFormatDate } from '@src/Common/Constants/getFormatDate';
import {
  DraftIcon,
  EventIcon,
  GameIcon,
  OnReviewIcon,
  RejectedIcon,
  RepoIcon
} from '@src/Components/Icons';

import { validateCoordinate } from '@src/Common/Helpers/validateCoordinate';
import Badge from '@src/Components/Atoms/Badge/Badge';
import styles from './DetailEventItem.module.scss';
import {
  TEventStatus,
  TEventType
} from '@src/Domain/MySubmission/MySubmission.interface';
import { UncoveredIcon } from '@src/Components/Icons/UncoveredIcon/UncoveredIcon';

type IDetailEventItem = {
  id: number | string;
  latlon: [number | undefined, number | undefined];
  investigation: string;
  date: string | undefined;
  locationName: string;
  type?: TEventType;
  status?: TEventStatus;
  onDelete?: () => void;
  onClick?: () => void;
};

const handleIconTitle = (type: string | undefined) => {
  switch (type) {
    case 'on-review':
      return <OnReviewIcon />;
    case 'draft':
      return <DraftIcon />;
    case 'rejected':
      return <RejectedIcon />;
    case 'uncovered':
      return <UncoveredIcon />;
    case 'dum':
    case 'report':
      return <EventIcon />;
    case 'casefile':
      return <RepoIcon />;
    default:
      return <GameIcon />;
  }
};

const DetailEventItem: React.FC<IDetailEventItem> = ({
  latlon = [0, 0],
  investigation,
  date,
  locationName,
  type,
  status = undefined,
  onDelete,
  onClick
}) => {
  const clickable = status === 'approved' ? true : false;
  return (
    <div
      className={
        styles['popup-content-wrapper'] +
        ' ' +
        (clickable ? styles['clickable'] : '')
      }
      data-testid="detail-event-item"
      onClick={onClick}
    >
      <div className={styles['top-content']}>
        <div className={styles['location-detail']}>
          <div className={styles['location-detail-left']}>
            <span className={styles['location-name']}>{locationName}</span>
            <span className={styles['coordinate']}>
              /{' '}
              {`${validateCoordinate(latlon[0])}, ${validateCoordinate(
                latlon[1]
              )}`}
            </span>
            {status !== undefined ? <Badge type={status} /> : null}
          </div>
          <div className={styles['location-detail-right']}>
            {onDelete ? (
              <button onClick={onDelete}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <mask
                    id="mask0_2527_122225"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_2527_122225)">
                    <path
                      d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.196 20.021 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.021 20.8043 17.55 21 17 21H7ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                      fill="#E4E4E4"
                    />
                  </g>
                </svg>
              </button>
            ) : null}
          </div>
        </div>
        <div className={styles['TitleContainer']}>
          <div className={styles['location-icons']}>
            {handleIconTitle(
              status === undefined || status === 'approved' ? type : status
            )}
          </div>
          <p className={styles['investigation']}>{investigation}</p>
        </div>
        <div>
          <p className={styles['date']}>
            <span>Event Date:</span>
            {date && (
              <span className={styles['date-time']}>
                {getFormatDate(date, false, false, '-')}
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DetailEventItem;
